import type {ClientProfile} from '../types';

// Colors sourced from official Go Telecom brand guidelines.
// Primary palette: #014952 Dark Teal | #016774 Bold Teal | #049394 Original Teal | #4CEADB Light Teal
// Typography: Gilroy (EN) + Readex Pro (AR).
export const goProfile: ClientProfile = {
  clientId: 'go',
  theme: {
    appTitle: 'GO Telecom Dashboard',
    brandName: 'GO Telecom',
    logoUrl: '/assets/clients/go/logo-official.png',
    loginLogoUrl: '/assets/clients/go/logo-light.png',
    loginBackgroundUrl: '/assets/clients/go/login-background.png',
    primaryColor: '#049394',
    designSystem: {
      colors: {
        primary:    '#049394', // Original Teal — brand primary
        secondary:  '#4CEADB', // Light Teal — accents, highlights
        grayText:   '#014952', // Dark Teal — headers, strong text
        grayUnit:   '#4A6B6A',
        error:      '#DC2626',
        warning:    '#D97706',
        success:    '#16A34A',
        // Sidebar background (#014952 Dark Teal) is set via --color-sidebar-bg in index.css
      },
      typography: {
        fontFamily:        'Readex Pro',        // Arabic
        fontFamilyHeading: 'Gilroy',            // English headlines (fallback: Inter)
      },
      themeClass: 'theme-go',
    },
  },
  // GO Telecom: stores + products + inventory + visits + marketer tracking.
  // No sales, invoices, payments, or anything billing-related.
  enabledModules: [
    'dashboard',
    'map',
    'stores-map',
    'stores',
    'store-deliveries',
    'visits',
    'products',
    'add-stock',
    'marketers',
    'marketer-tracking',
    'users',
  ],
  defaultLandingPath: '/dashboard'
};
